import React, { useEffect, useContext, useState, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { LayoutContext } from "App/common/hoc/Layout";
import { checkValidity } from "utils";
import { VALIDATION } from "consts";
import { inviteUsersStart } from "store/actions";

const AddUsers = props => {
  const { lMethods, lState } = useContext(LayoutContext);
  const [emailsInput, setEmailsInput] = useState({
    key: "Emails",
    value: [],
    validation: { required: true, isEmail: true },
    valid: true,
    error: ""
  });

  useEffect(() => {
    if (
      props.inviteStatus &&
      props.inviteStatus.invalid_email &&
      props.inviteStatus.invalid_email.length > 0
    ) {
      props.inviteStatus.invalid_email = [];
      props.inviteStatus.invite_email = [];
    }
  }, []);

  // document.addEventListener("keydown", (e) => {
  //   if (e.keyCode === 13 && lState.popup.show) {
  //     formSubmitHandler();
  //   }
  // });

  useEffect(() => {
    lMethods.updatePopupParams({
      execute: formSubmitHandler
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailsInput]);

  useEffect(() => {
    lMethods.updatePopupParams({
      loading: props.users.popupLoading,
      error: props.addUsers.error
    });
    if (props.addUsers.updated) lMethods.closePopup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.addUsers]);

  useEffect(() => {
    if (
      emailsInput.value.length > 0 &&
      props.inviteStatus.invalid_email.length > 0 &&
      !props.users.popupLoading
    ) {
      lMethods.openPopup("usersFailedList", {
        execute: null
      });
    } else if (
      emailsInput.value.length > 0 &&
      props.inviteStatus.invalid_email.length === 0 &&
      !props.users.popupLoading
    ) {
      lMethods.closePopup();
    }
  }, [props.users.popupLoading]);

  function findDuplicates(arr) {
    return arr.filter((item, index) => arr.indexOf(item) != index);
  }

  function inputChangeHandler(val) {
    const updatedEmailsInput = { ...emailsInput };
    let newValues = val.split(",");

    newValues = newValues.map(val => val.trim());
    updatedEmailsInput.value = newValues;
    const emailsLength = newValues.filter(val => val).length;
    if (emailsLength > 20) {
      updatedEmailsInput.valid = false;
      updatedEmailsInput.error = "Emails entered are more than the limit";
    } else {
      updatedEmailsInput.valid = true;
    }

    setEmailsInput(updatedEmailsInput);
  }

  function formSubmitHandler() {
    let isFormValid = true;
    const updatedEmailsInput = { ...emailsInput };
    updatedEmailsInput.value = updatedEmailsInput.value.filter(function(el) {
      return el != "";
    });
    const updatedEmailsObj = { emails: null };

    let validationObj = {
      isValid: false,
      errMsg: ""
    };

    if (updatedEmailsInput.value) {
      if (updatedEmailsInput.value.length === 0) {
        validationObj.isValid = false;
        validationObj.errMsg = "Email field cannot be blank";
      } else if (findDuplicates(updatedEmailsInput.value).length > 0) {
        validationObj.isValid = false;
        validationObj.errMsg = "Duplicate emails are present";
      } else if (updatedEmailsInput.value.length > 20) {
        validationObj.isValid = false;
        validationObj.errMsg = "Emails entered are more than the limit";
      } else if (updatedEmailsInput.value.length > 1)
        for (let email of updatedEmailsInput.value) {
          if (email.length > 50) {
            validationObj.isValid = false;
            validationObj.errMsg = VALIDATION.backupSettings.email.long;
          } else {
            validationObj = checkValidity(
              email.trim() !== "" ? email.trim() : "",
              updatedEmailsInput.validation
            );
          }
          if (!validationObj.isValid) break;
        }
      else {
        const email = updatedEmailsInput.value[0] || "";
        if (updatedEmailsInput.value[0].length > 50) {
          validationObj.isValid = false;
          validationObj.errMsg = VALIDATION.backupSettings.email.long;
        } else {
          validationObj = checkValidity(
            email.trim() !== "" ? email.trim() : "",
            updatedEmailsInput.validation
          );
        }
      }
    }

    updatedEmailsInput.valid = validationObj.isValid;
    updatedEmailsInput.error = validationObj.errMsg;

    if (!updatedEmailsInput.valid) isFormValid = false;

    updatedEmailsObj.emails = updatedEmailsInput.value;

    setEmailsInput(updatedEmailsInput);

    if (isFormValid) {
      props.inviteUsersStart(updatedEmailsObj, false);
    }
  }

  return (
    <React.Fragment>
      {props.users.popupLoading && (
        <div className="">
          <div className="popup_loader_bg   "></div>
          <div className="mirror_loader flex_center">
            <img
              src={
                process.env.REACT_APP_STATIC_URL + "/images/mirror_loader.gif"
              }
              alt="Mirror_Loader"
            />
          </div>
        </div>
      )}
      <div className="input_group">
        <div className="input_field_msg input_textarea">
          <div>
            <label>Email Address</label>
            <textarea
              className="invite_email_box"
              cols={30}
              rows={10}
              autoFocus={true}
              value={emailsInput.value && emailsInput.value.join(",")}
              onChange={e => inputChangeHandler(e.target.value)}
            />
          </div>
        </div>
      </div>

      {!emailsInput.valid && (
        <div>
          <span className="error-msg">{emailsInput.error}</span>
        </div>
      )}

      <p className="txtarea_note">
        <strong>Note: </strong>Enter up to 20 email addresses, separated by
        commas.
      </p>
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    addUsers: state.users.addUsers,
    inviteStatus: state.users.addUsers.inviteStatus,
    users: state.users
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ inviteUsersStart }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AddUsers);
